import { useTenant } from '../../hooks/useTenant';

/**
 * TenantGuard - Protege las rutas para asegurar que el tenant está activo.
 * Muestra un mensaje si el tenant está suspendido o cancelado.
 */
export default function TenantGuard({ children }: { children: React.ReactNode }) {
  const { tenant, loading, isSuspended } = useTenant();

  // Mientras carga, no bloquear
  if (loading || !tenant) return <>{children}</>;

  if (isSuspended) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md text-center">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-error-warning-line text-3xl text-yellow-600"></i>
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Cuenta Suspendida</h2>
          <p className="text-gray-600 mb-4">
            Tu cuenta de <span className="font-semibold">{tenant.name}</span> ha sido suspendida.
            Contacta al administrador del servicio para reactivarla.
          </p>
          <div className="bg-yellow-50 rounded-lg p-4 text-sm text-yellow-800">
            <p>Si crees que esto es un error, por favor comunícate con soporte.</p>
          </div>
        </div>
      </div>
    );
  }

  if (tenant.status === 'cancelled') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-close-circle-line text-3xl text-red-600"></i>
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Cuenta Cancelada</h2>
          <p className="text-gray-600 mb-4">
            La cuenta de <span className="font-semibold">{tenant.name}</span> ha sido cancelada.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
